import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { If, Then, Else } from 'react-if';
import { useToggle } from 'react-use';
import { compose } from 'recompose';
import queryString from 'query-string';
import Drift from 'react-driftjs';

import { useSelector } from '../../hooks/useSelector';
import { useActions } from '../../hooks/useActions';
import { useAuth } from '../../hooks/useAuth';
import { withAuthorization } from '../../session';
import { checkPendingTransactions } from '../../firebase/api/users';

import Container from 'reactstrap/es/Container';
import WelcomeModal from './../Posts/components/WelcomeModal';
import SubCategory, { postsPages } from '../../components/projectSubCategory/SubCategory';
import AppLoader from '../../components/appLoader/AppLoader';

import './PendingPosts.css';

export const pendingSubCategories = {
    pending: 'Pending Posts',
    approved: 'Approved Posts',
    rejected: 'Rejected Posts',
};

const PendingPosts = () => {
    const {
        currentUser: { uid, email, pendingPayments, stripeUserId, role },
    } = useAuth()

    const { pending, approved, rejected, loading } = useSelector(state => state.pendingPosts)
    const { pendingPostCount } = useSelector(state => state.notifications)
    const { activeCategory } = useSelector(state => state.categories)
    const { fetchPendingPosts, fetchNewInvitationsPostCount } = useActions()
    const location = useLocation()
    const navigate = useNavigate()

    const [initialWelcomeModalOpenState, toggleWelcomeModalState] = useToggle(false)

    useEffect(() => {
        if (role === 'ADMIN') {
            fetchPendingPosts({ email, activeCategory })
            fetchNewInvitationsPostCount({ email, uid })
        } else {
            navigate('/posts')
        }
    }, [email, uid, activeCategory, role])

    useEffect(() => {
        if (stripeUserId && pendingPayments.length) {
            checkPendingTransactions(uid).then(r => r);
        }
    }, []);

    useEffect(() => {
        const parsedQuery = queryString.parse(location.search);
        if (parsedQuery.welcome) {
            toggleWelcomeModalState();
            window.history.pushState({}, document.title, window.location.pathname);
        }
    }, []);


    return (
        <>
            <Container fluid={true} className="posts__container">
                <If condition={loading}>
                    <Then>
                        <div className="posts__title-container-outer">
                            <div className="height-full align-items-center d-flex justify-content-center posts__title">
                                <AppLoader />
                            </div>
                        </div>
                    </Then>
                    <Else>
                            <div className='posts-wrap'>
                                <div className='posts-top-space' />
                                <div className='posts-subcategories-wrap'>
                                    <SubCategory
                                        page={postsPages.pending}
                                        subCategoryTitle={pendingSubCategories.pending}
                                        subCategories={pendingSubCategories}
                                        data={pending}
                                        pendingPostsCount={pendingPostCount}
                                    />
                                    <SubCategory
                                        page={postsPages.pending}
                                        subCategoryTitle={pendingSubCategories.approved}
                                        subCategories={pendingSubCategories}
                                        data={approved}
                                    />
                                    <SubCategory
                                        page={postsPages.pending}
                                        subCategoryTitle={pendingSubCategories.rejected}
                                        subCategories={pendingSubCategories}
                                        data={rejected}
                                    />
                                </div>
                            </div>
                    </Else>
                </If>
            </Container>
            <WelcomeModal openState={initialWelcomeModalOpenState} />
            <Drift appId="hhtzk8ssng43" />
        </>
    );
};

PendingPosts.propTypes = {};

const condition = authUser => !!authUser;
const enhance = compose(withAuthorization);

export default compose(enhance(condition), React.memo)(PendingPosts);
